import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, HrefPill } from '../../components';
import { getIcon } from '../iconMap';

function ProspectusDownload({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const c = data.card || {};
  const ins = data.inside || {};
  const CI = getIcon(c.icon);
  const updateC = (patch) => update({ card: { ...c, ...patch } });
  const updateIns = (patch) => update({ inside: { ...ins, ...patch } });
  const ctas = c.ctas || [];
  const updateCta = (i, patch) => {
    const next = ctas.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    updateC({ ctas: next });
  };
  const insItems = ins.items || [];
  const updateInsItem = (i, t) => {
    const next = [...insItems];
    next[i] = t;
    updateIns({ items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-8 items-stretch">
        <Reveal>
          <div className="relative rounded-3xl p-10 bg-gradient-to-br from-olive-deep to-olive-footer text-white overflow-hidden h-full flex flex-col">
            <div className="absolute -top-32 -right-32 w-72 h-72 rounded-full bg-accent/20 blur-3xl" />
            <CI className="text-accent" size={48} />
            <EditableText value={c.heading} onChange={(t) => updateC({ heading: t })} as="h3" className="font-display text-3xl mt-6" />
            <EditableText value={c.body} onChange={(t) => updateC({ body: t })} as="p" multiline className="mt-4 text-white/80 leading-relaxed" />
            <div className="mt-auto pt-8 flex flex-wrap gap-3">
              {ctas.map((cta, i) => {
                const variant = cta.variant || 'accent';
                const cls = variant === 'accent' ? 'btn-accent' : variant === 'outline-light' ? 'btn-outline-light' : 'btn-primary';
                const CtaIcon = cta.icon ? getIcon(cta.icon) : null;
                const isExt = cta.external;
                const props = isExt ? { target: '_blank', rel: 'noreferrer' } : {};
                return (
                  <div key={i} className="inline-flex flex-col">
                    <a href={cta.href || '#'} className={cls} {...props}>
                      {CtaIcon && <CtaIcon size={16} />}
                      <EditableText value={cta.label} onChange={(t) => updateCta(i, { label: t })} as="span" />
                      {variant === 'outline-light' && <ArrowRight size={16} />}
                    </a>
                    <HrefPill value={cta.href} onChange={(h) => updateCta(i, { href: h })} />
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="card-surface p-10 h-full">
            <EditableText value={ins.heading} onChange={(t) => updateIns({ heading: t })} as="h3" className="font-display text-2xl" />
            <ul className="mt-6 space-y-4">
              {insItems.map((item, i) => (
                <li key={i} className="flex gap-3"><Check size={20} className="text-olive shrink-0 mt-0.5" /><EditableText value={item} onChange={(t) => updateInsItem(i, t)} as="span" className="text-ink/80" /></li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default ProspectusDownload;
